document.addEventListener('DOMContentLoaded', function () {
  const loginForms = document.querySelectorAll('form[action*="/account/login"]') || [];

  if(loginForms.length > 0) {
    loginForms.forEach(form => {
      form.addEventListener('submit', function () {
        localStorage.setItem("pre_login_cart", getCookie("cart"));
      });
    });
  }

});

function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);
  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }
  return null;
}
